const Styles = {
  contentContainerStyle: {
    backgroundColor: 'white',
    width: '90%',
    marginTop: 120,
    paddingTop: 50,
    paddingBottom: 80,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  noBookings: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center'
  },
  noBookingTitle: {
    fontSize: 22,
    color: '#d3d3d3',
    marginTop: 80,
    textAlign: 'center'
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/containers/MyBookingsHandler/styles.js